<template>
  <div id="snackbar" :class="{ show: show, fadeout: fadeout }">
    <div id="snackbar-container">
      <div id="snackbar-message">
        {{ message }}
      </div>

      <div id="snackbar-button" v-if="showButton">
        <button type="button" class="toast-button" @click="execCallback">
          {{ $t('system.button_new_version_available') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { SNACKBAR_MESSAGE } from '@/helpers/eventBus'

export default {
  name: 'Snackbar',
  data: () => ({
    show: false,
    fadeout: false,
    showButton: false,
    callback: () => {},
    message: ''
  }),
  methods: {
    execCallback() {
      if (typeof this.callback === 'function') {
        this.callback()
      }
    }
  },
  created() {
    this.$eventBus.$on(SNACKBAR_MESSAGE, payload => {
      // discard message if already showing a message
      if (this.show && !payload.bypass) return

      this.message = payload.message
      if (payload.action) {
        this.showButton = true
        this.callback = payload.action
      }

      let duration = 4000
      if (payload.duration) {
        duration = payload.duration
      }

      this.show = true

      if (!payload.infinite) {
        setTimeout(() => {
          this.fadeout = true
        }, duration - 500)

        setTimeout(() => {
          this.show = false
          this.showButton = false
          this.message = ''
          this.fadeout = false
          this.callback = () => {}
        }, duration)
      }
    })
  }
}
</script>

<style lang="scss" scoped>
#snackbar {
  visibility: hidden; /* Hidden by default. Visible on click */
  width: 100%; /* Set a default minimum width */
  margin-left: -50%; /* Divide value of min-width by 2 */
  // background-color: #333; /* Black background color */
  color: rgb(0, 0, 0); /* Black text color */
  text-align: center; /* Centered text */
  padding-top: 16px; /* Padding */
  padding-bottom: 16px; /* Padding */
  position: fixed; /* Sit on top of the screen */
  z-index: 1; /* Add a z-index if needed */
  left: 50%; /* Center the snackbar */
  bottom: 0px; /* 30px from the bottom */
  background: white;
}

/* Show the snackbar when clicking on a button (class added with JavaScript) */
#snackbar.show {
  visibility: visible; /* Show the snackbar */
  /* Add animation: Take 0.5 seconds to fade in and out the snackbar.
    However, delay the fade out process for 2.5 seconds */
  -webkit-animation: fadein 0.5s;
  animation: fadein 0.5s;
}

#snackbar.fadeout {
  -webkit-animation: fadeout 0.5s;
  animation: fadeout 0.5s;
}

/* Animations to fade the snackbar in and out */
@-webkit-keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@-webkit-keyframes fadeout {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

@keyframes fadeout {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.toast-button {
  border-radius: 5px;
  background-color: white;
  color: black;
}

#snackbar-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 8px;
  margin-right: 8px;
  justify-content: center;
}

#snackbar-button {
  padding-left: 4px;
  padding-right: 4px;
}
</style>
